/* eslint-disable no-unused-vars */

import React, {lazy} from "react";
import { createBrowserHistory } from "history";
import { I18nPropvider, LOCALES } from './i18n';
import { HashRouter,BrowserRouter, Router, Route, Switch, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { logedIn } from "~/actions/auth.action";
import { LinearProgress } from "@material-ui/core";
import ScrollToTop from '@components/ScrollToTop'

// core components
import Admin from "./layouts/Admin";
import AuthRegisterRoutes from './routes/authRegister.routes'
// import RTL from "./layouts/RTL";
// import "./assets/css/material-dashboard-react.css";// added in App.css
import './App.css';
import ('crm/css')
  .catch((err)=>console.log('%c crm CSS err','background:#fff;color:orange;',err))

import { StylesProvider, createGenerateClassName } from "@material-ui/core/styles";

const generateClassName = createGenerateClassName({
  productionPrefix: "lay-mf",
  disableGlobal:true
});

const hist = createBrowserHistory();


function App (props) {
  const localData = localStorage.getItem('token')&&localStorage.getItem('user')
  const mainRoutAuth = props.isAuthenticated || localData;

  if(localData){
    props.logedIn({...JSON.parse(localStorage.getItem('user')), token:localStorage.getItem('token')})
  }

  return (
    <StylesProvider generateClassName={generateClassName} >
      <I18nPropvider locale={props.language}>
        <div className="app">
          <Router history={hist}>{/* Router with history={hist} instead BrowserRouter*/}
            <ScrollToTop />
            {mainRoutAuth && 
              <Switch>
                <Route path="/admin" component={Admin} />
                <Route exact path="/">
                  <Redirect to="/admin/dashboard" />
                </Route>
              </Switch>
              }
              <React.Suspense fallback={<LinearProgress />}>
                <AuthRegisterRoutes />
              </React.Suspense>
              {/* {!mainRoutAuth?<Redirect to="/login" />:null} */}
              {props.children}
            
          </Router>
        </div>
      </I18nPropvider>
    </StylesProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.authReducer.isAuthenticated,
    authError: state.authReducer.authError,
    language:state.i18nReducer.language
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logedIn:(userData)=>dispatch(logedIn(userData))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
